// Note: User Avatar Component

import { Avatar, type AvatarProps, Tooltip } from "@mantine/core"
import type { TUserBase } from "@/types"
import { buildUserURL } from "@/utils"
import { AppLink } from "../utils"

interface IProps extends AvatarProps {
  user: TUserBase
  withLink?: boolean
  withTooltip?: boolean
}

export function UserAvatar({ user, radius = "100%", withLink, withTooltip, ...props }: IProps) {
  if (!user) return null

  const name = user.full_name || user.name
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
  let avatar = (
    <Avatar src={user.picture} alt={name} title={withTooltip ? undefined : name} radius={radius} {...props}>
      {initials}
    </Avatar>
  )

  if (user.id) {
    if (withTooltip)
      avatar = (
        <Tooltip label={name} position="top" px="xs" withArrow withinPortal>
          {avatar}
        </Tooltip>
      )
    if (withLink) {
      avatar = (
        <AppLink key={user.id} href={buildUserURL(user.id)}>
          {avatar}
        </AppLink>
      )
    }
  }

  return avatar
}
